import React, { useState, useRef, useEffect } from 'react';
import useNavigateWithParams from '../../hooks/useNavigateWithParams';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

const Header = ({ actions, lastSavedText }) => {
  const navigate = useNavigateWithParams();
  const { user, signOut } = useAuth();

  const isProduction = process.env.REACT_APP_SERVER_ENVIRONMENT === 'prod' || process.env.REACT_APP_SERVER_ENVIRONMENT === 'dev';

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // ✅ NEW

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-container">

        {/* LEFT */}
        <div className="header-left" onClick={() => navigate('/dashboard')}>
          <div className="header-logo">
            <img src="/genentech-logo.svg" alt="Genentech Logo" />
          </div>
          <div className="header-divider"></div>
          <div className="header-app-info">
            <img src="/builder-icon.svg" alt="" />
            <span className="header-title">
              Conference Quick Guide Builder
            </span>
          </div>
          {!isProduction && (
            <span className="header-sandbox-badge">Sandbox</span>
          )}
        </div>

        {/* RIGHT */}
        <div className="header-right" ref={dropdownRef}>

          {/* ===== DESKTOP ONLY ===== */}
          <div className="desktop-only">
            {lastSavedText && (
              <div className="header-last-saved">{lastSavedText}</div>
            )}

            {actions && <div className="header-actions">{actions}</div>}

            <div
              className="user-profile"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {user?.avatar_url ? (
                <img
                  src={user.avatar_url}
                  alt=""
                  className="user-avatar"
                  referrerPolicy="no-referrer"
                />
              ) : (
                <img src="/user-icon.svg" alt="" />
              )}
              <span className="user-name">{user?.name || 'Jane Doe'}</span>
              <svg
              className={`dropdown-icon ${dropdownOpen ? 'open' : ''}`}
              width="36"
              height="36"
              viewBox="0 0 16 16"
              fill="none"  >         
              <path
                d="M4 6L8 10L12 6"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            </div>

            {dropdownOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <div className="dropdown-user-info">
                    <span className="dropdown-user-name">
                      {user?.name || 'Jane Doe'}
                    </span>
                    <span className="dropdown-user-email">
                      {user?.email}
                    </span>
                  </div>
                </div>

                <div className="dropdown-divider"></div>

                <button className="dropdown-item" onClick={handleLogout}>
                  Log out
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.6667 11.3333L14 8L10.6667 4.66667"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 8H6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                </button>
              </div>
            )}
          </div>

          {/* ===== MOBILE HAMBURGER ===== */}
            <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <img
              src={mobileMenuOpen ? '../../images/headers/close.svg' : '../../images/headers/open.svg'}
              alt="menu toggle"
              className="mobile-menu-icon"
            />
          </button>
        </div>
      </div>

      {/* ===== MOBILE MENU PANEL ===== */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-user">
            <strong>{user?.name || 'Jane Doe'}</strong>
            <span>{user?.email}</span>
          </div>

          <button className="mobile-logout" onClick={handleLogout}>
            Log out
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.6667 11.3333L14 8L10.6667 4.66667"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 8H6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
